
import React from 'react';
import Logo from './Logo';
import { Facebook, Twitter, Linkedin, Instagram, Youtube } from 'lucide-react';

function Footer() {
  const currentYear = new Date().getFullYear();
  
  const footerLinks = [
    {
      title: "Company",
      links: [
        { name: "Blog", href: "/blog" },
      ]
    },
    {
      title: "Resources",
      links: [
        { name: "Community", href: "https://www.facebook.com/share/g/hr6idZ8zRkis9FKE/" },
        { name: "Free Guides", href: "https://www.youtube.com/playlist?list=PLevLP9Na0UzlfFKAYS0pPNqJlbKihTdhF" },
        { name: "Webinars", href: "https://www.facebook.com/groups/530406235979080/permalink/683515007334868/" },
      ]
    },
  ];
  
  const socialLinks = [
    { name: "Facebook", icon: <Facebook size={20} />, href: "https://www.facebook.com/share/g/hr6idZ8zRkis9FKE/" },
    { name: "Twitter", icon: <Twitter size={20} />, href: "https://x.com/GetMarter_" },
    { name: "Instagram", icon: <Instagram size={20} />, href: "https://www.instagram.com/getmarter" },
    { name: "YouTube", icon: <Youtube size={20} />, href: "https://www.youtube.com/@GetMarter" },
    { name: "Discord", icon: <i className="pi pi-discord"/>, href: "https://discord.gg/9VfPNDyM9h" },
  ];

  return (
    <footer className="footer pt-6">
      <div className="container">
        <div className="columns is-variable is-8">
          <div className="column is-4">
            <Logo />
            <p className="mt-4 has-text-marter-dark-gray" style={{maxWidth: "25rem"}}>
              Empowering thousands of sellers, brands, and companies to sell on Walmart with ease.
            </p>
            <div className="mt-4 is-flex">
              {socialLinks.map((social, index) => (
                <a 
                  key={index}
                  href={social.href}
                  className="mr-3 has-text-marter-dark-gray"
                  aria-label={social.name}
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>
          
          {footerLinks.map((category, index) => (
            <div key={index} className="column">
              <h4 className="title is-5 has-text-marter-dark-blue mb-4">
                {category.title}
              </h4>
              <ul>
                {category.links.map((link, i) => (
                  <li key={i} className="mb-2">
                    <a 
                      href={link.href}
                      className="has-text-marter-dark-gray"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        
        <hr className="mt-6" />
        
        <div className="level py-5">
          <div className="level-left">
            <div className="level-item">
              <p className="is-size-7 has-text-marter-dark-gray">
                © {currentYear} Marter. All rights reserved.
              </p>
            </div>
          </div>
          <div className="level-right">
            <div className="level-item">
              <div className="is-flex">
                <a href="https://www.getmarter.com/privacy" className="mr-4 is-size-7 has-text-marter-dark-gray">
                  Privacy Policy
                </a>
                <a href="https://www.getmarter.com/terms.pdf" className="mr-4 is-size-7 has-text-marter-dark-gray">
                  Terms of Service
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
